var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
function IconCloseComponent(props, ref) {
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    _b = props.prefix,
    prefix = _b === void 0 ? 'arco' : _b,
    _c = props.width,
    width = _c === void 0 ? '1em' : _c,
    _d = props.height,
    height = _d === void 0 ? '1em' : _d,
    _e = props.useCurrentColor,
    useCurrentColor = _e === void 0 ? true : _e,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: prefix + "-icon " + prefix + "-icon-close " + className,
    width: width,
    height: height,
    viewBox: "0 0 17 17",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_716f6b3059__clip0_361_32912)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.725 4.964l.353-.353-.707-.707-.353.353-3.535 3.534L4.95 4.257l-.353-.353-.707.707.353.353 3.534 3.534-3.534 3.535-.353.353.707.707.353-.353 3.534-3.534 3.535 3.534.353.353.707-.707-.353-.353L9.19 8.498l3.534-3.534z",
    fillOpacity: "1"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_716f6b3059__clip0_361_32912"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(.483 .499)",
    d: "M0 0h16v16H0z"
  }))));
}
var IconClose = /*#__PURE__*/React.forwardRef(IconCloseComponent);
export default IconClose;